import { createBrowserRouter } from 'react-router-dom';
import { publicMiddleware, authAdminMiddleware, authMiddleware } from '../app/middlewares';
import { AdminRoutes } from './admin';
import { AuthRoutes } from './auth';
import { CommonRoutes } from './common';
import { MainLayout, AuthLayout } from '../app/layouts';
import { ErrorPage } from 'pages/errorPage';

export const Routes = [
  {
    path: '/',
    loader: authMiddleware,
    element: <MainLayout />,
    errorElement: <ErrorPage />, 
    children: CommonRoutes,
  },
  {
    path: '/auth',
    loader: publicMiddleware,
    element: <AuthLayout />,
    errorElement: <ErrorPage />, 
    children: AuthRoutes,
  },
  {
    path: '/admin',
    element: <MainLayout />,
    errorElement: <ErrorPage />, 
    loader: authAdminMiddleware,
    children: AdminRoutes,
  },
];

export default createBrowserRouter(Routes);
